var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStackedImg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.15,
    fill: "#207DF7",
    stroke: "white",
    strokeWidth: 1.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 5.99829C8 5.99829 7 12.9983 6.5 15.9983C6.83334 15.9983 7.16638 15.9983 7.49912 15.9983C7.83211 14.3318 8.66573 13.4151 10 13.2483C12 12.9983 13.5 11.2483 14 9.74829L13.25 9.24829C13.4166 9.08163 13.5834 8.91496 13.75 8.74829C14.25 8.24829 14.7521 7.49829 15.5 5.99829Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackedImg3);
export default __webpack_public_path__ + "static/media/stacked_img_3.f4f92cc965d118aafce774b174f406ca.svg";
export { ForwardRef as ReactComponent };